import { Component, OnInit, AfterViewInit } from '@angular/core';
import { BlogService } from '../blogs/blog.service';
import { IArticle } from '../blogs/blog';
import { Router } from '@angular/router';

@Component({
  selector: '[mft-rssnewsfeed]',
  templateUrl: "./rssnewsfeed.component.html"
})
export class RssNewsFeedComponent implements OnInit, AfterViewInit {
  articlesList: IArticle[];
  constructor(
    public blogService: BlogService,
    private router: Router,
  ) {

  }
  ngOnInit() {
    this.loadArticlesList();
  }

  ngAfterViewInit() {

  }

  loadArticlesList() {
    this.blogService.getDrawingArticlesList()
      .subscribe(
      (articles: IArticle[]) => {
        this.articlesList = articles.slice(0,2);
      },
      (error: any) => {
        this.blogService.showError("Articles retrieval problem", <any>error)
      }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/home/rssnewsfeed.component.ts